/*
 * @Author: liyxt
 * @Date: 2020-02-19 15:18:51
 * @LastEditors: bbqin
 * @LastEditTime: 2023-04-23 17:11:48
 * @Description: file content
 */
import React, { Component } from 'react';
import { ScrollElement, ScrollLink } from './scroll';
import { scrollSpy } from 'react-scroll';

import { microAppUtil } from '@platform/api';

require('./index.less');

let timer = null;

/**
 * @namespace Anchor
 */
/**
 * Scroll组件的参数描述
 * @memberof Anchor
 * @component Anchor
 * @property {ScrollLink} children - ScrollLink 或者 包含ScrollLink.props的dom
 */
class Anchor extends Component {
    constructor(props) {
        super(props);
        let arrLen = [].concat(...this.props.children);
        arrLen = arrLen.filter(e => e !== null);
        this.state = {
            arrLen, // 处理下没有children的情况  bbqin
            hover: false,
            currentIndex: 0,
        };
        this.scrollContainer = microAppUtil.getPopContainer();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // 改变传入的 children 
        let arrLen = [].concat(...nextProps.children);
        arrLen = arrLen.filter(e => e !== null);
        if ('children' in nextProps) {
            this.setState({ arrLen });
        }
    }

    hoverAnchor = (flag, delay) => {
        if (delay === true) {
            timer = setTimeout(() => {
                this.setState({ hover: flag });
            }, 500);
        } else {
            clearTimeout(timer);
            this.setState({ hover: flag });
        }

    };

    activeOnlyOne = (index, activeClass = 'active') => {
        const affixContent = this.affixContent;
        if (affixContent) {
            [...affixContent.children].forEach(item => {
                item && item.classList.remove(activeClass);
            });
            const activeItem = [...affixContent.children][index];
            activeItem && activeItem.classList.add(activeClass);
        }
    }

    render() {
        let arrLength = this.state.arrLen.length;
        // 楼层组件在dragWidthCom组件内时改变固定定位为绝对定位
        // 楼层组件在dragHeightCom组件内时改变固定定位为绝对定位
        let containerIdArr = ['dragWidthCom_left', 'dragHeightCom_bottom'];
        let containerId = this.state.arrLen[0]?.props?.containerId;
        let isInDragCom = containerIdArr.includes(containerId) || this.state.arrLen[0]?.props.isSticky;
        let affixContentHeight = isInDragCom && document.querySelector(`#${containerId}`) ? document.querySelector(`#${containerId}`).offsetHeight - 100 : 0;
        let style = { position: 'sticky', right: 0, top: 0, zIndex: 101 };
        return (
            <div style={isInDragCom ? style : {}}>
                <div
                    fieldid="stairs-area"
                    className={`${this.state.hover ? (arrLength >= 9 ? 'showborder-xl' : 'showborder') : ''}  lightapp-component-wrap`}
                    onMouseLeave={this.hoverAnchor.bind(this, false)}
                    onMouseEnter={this.hoverAnchor.bind(this, true)}
                    {...this.props}
                    style={{ 
                        display: this.state.hover ? 'block' : 'none', 
                        position: isInDragCom ? 'absolute' : 'fixed', 
                        maxHeight: isInDragCom ? 'initial' : '80%',
                        //top: '100px',
                    }}
                >
                    <div ref={elem => { this.affixContent = elem; }} className="component-affix-content" style={{ maxHeight: isInDragCom ? affixContentHeight : '', overflow: 'auto' }}>
                        {React.Children.map(this.state.arrLen, (ele, index) => {
                            if (Number(arrLength) === Number(index + 1)) {
                                return (
                                    <div className='anchor-scroll-link-item'>
                                        <ScrollLink
                                            to={ele.props.to}
                                            spy={ele.props.spy}
                                            containerId={ele.props.containerId}
                                            smooth={ele.props.smooth}
                                            duration={ele.props.duration}
                                            offset={ele.props.offset}
                                            activeClass="active"
                                            onClick={() => {
                                                // NCC-196080 先执行领域的点击事件，再去渲染楼层
                                                ele.props.clickFun && ele.props.clickFun();
                                                window.requestAnimationFrame(() => {
                                                    this.setState({ currentIndex: index, hover: true }, () => {
                                                        this.activeOnlyOne(index, 'nice-active');
                                                    });
                                                });
                                                this.clickToActive = index;
                                            }}
                                            onSetActive={(to, toElement) => {
                                                if (this.clickToActive) {
                                                    this.activeOnlyOne(this.clickToActive, 'nice-active');
                                                    // 300ms 内只选中一个
                                                    setTimeout(()=> {
                                                        this.clickToActive = null;
                                                    }, 300);
                                                } else {
                                                    // 只执行最后一次
                                                    if (this.isSetActive) {
                                                        clearTimeout(this.isSetActive);
                                                    }
                                                    this.isSetActive = setTimeout(() => {
                                                        this.activeOnlyOne(index, 'nice-active');
                                                        this.isSetActive = null;
                                                    }, 300);
                                                }
                                            }}
                                            container={this.scrollContainer}
                                        // className={ this.anchor_title_index(index) }
                                        >
                                            <div>
                                                <span className="stairs-icon">
                                                    <div className="circle-center" />
                                                </span>
                                                <span className="stairs-title">
                                                    {ele && ele.props.children && ele.props.children.props.children}
                                                </span>
                                            </div>
                                        </ScrollLink>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className='anchor-scroll-link-item'>
                                        <ScrollLink
                                            to={ele.props.to}
                                            spy={ele.props.spy}
                                            containerId={ele.props.containerId}
                                            smooth={ele.props.smooth}
                                            duration={ele.props.duration}
                                            offset={ele.props.offset}
                                            activeClass="active"
                                            onClick={() => {
                                                // NCC-196080 先执行领域的点击事件，再去渲染楼层
                                                ele.props.clickFun && ele.props.clickFun();
                                                window.requestAnimationFrame(() => {
                                                    this.activeOnlyOne(index, 'nice-active');
                                                });
                                                this.clickToActive = index;
                                            }}
                                            onSetActive={(to, toElement) => {
                                                if (this.clickToActive) {
                                                    this.activeOnlyOne(this.clickToActive, 'nice-active');
                                                    // 300ms 内只选中一个
                                                    setTimeout(()=> {
                                                        this.clickToActive = null;
                                                    }, 300);
                                                } else {
                                                    // 只执行最后一次
                                                    if (this.isSetActive) {
                                                        clearTimeout(this.isSetActive);
                                                    }
                                                    this.isSetActive = setTimeout(() => {
                                                        this.activeOnlyOne(index, 'nice-active');
                                                        this.isSetActive = null;
                                                    }, 300);
                                                }
                                            }}
                                            onSetInactive={(to, toElement) => {
                                                console.log(to, toElement);
                                            }}
                                            container={this.scrollContainer}
                                        // className={ this.anchor_title_index( index ) }
                                        >
                                            <div>
                                                <span className="stairs-icon">
                                                    <div className="circle-center" />
                                                    <div className="vertical-line" />
                                                </span>
                                                <span className="stairs-title">
                                                    {ele && ele.props.children && ele.props.children.props.children}
                                                </span>
                                            </div>
                                        </ScrollLink>
                                    </div>
                                );
                            }
                        })}
                    </div>
                </div>
                <div
                    className='lightapp-component-affix-wrap'
                    onMouseLeave={this.hoverAnchor.bind(this, false, true)}
                    onMouseEnter={this.hoverAnchor.bind(this, true)}
                    style={{ 
                        position: isInDragCom ? 'absolute' : 'fixed',
                        //top: '120px',
                    }}
                >
                    <div className="loutiTubiao-wrap">
                        <span className="icon iconfont icon-loucengtubiao" />
                    </div>
                </div>

            </div>

        );
    }

    componentWillUnmount() {
        let containers = [document, ...new Set(this.state.arrLen.filter(e => e?.props?.containerId).map(e => {
            return document.getElementById(e.props.containerId);
        }))];

        containers.forEach(container => {
            container && (container.spyCallbacks = []);
        });

        scrollSpy.scrollSpyContainers = scrollSpy.scrollSpyContainers.filter(e => !containers.includes(e));
    }
}
/**
 * Scroll组件的参数描述
 * @memberof Anchor
 * @component ScrollElement
 * @property {string} name - 滚动元素的名称，唯一
 */
Anchor.ScrollElement = ScrollElement;

/**
 * Scroll组件的参数描述
 * @memberof Anchor
 * @component ScrollLink
 * @property {string} to - 要滚动到的目标
 * @property {string} containerId - 用于侦听滚动事件并在中执行滚动的容器 Id
 * @property {object} container - 用于侦听滚动事件并在中执行滚动的容器
 * @property {string} activeClass - 激活到元素的class
 * @property {boolean} spy - 滚动到目标位置时选中link
 * @property {boolean|string} smooth - 滚动动画
 * @property {number} offset - 滚动的补偿长度px（类似padding）
 * @property {number} delay - 滚动前等待x毫秒
 * @property {boolean} isDynamic - 如果必须重新计算距离，如果有展开的内容等。
 * @property {function(event): void} onClick - link 点击事件
 * @property {number|function(deltaTop): void} duration - 滚动动画的时间-可以是一个数字或函数（`function（scrollDistanceInPx）{return duration；}`），它允许在运行时进行更精细的控制
 * @property {function(to, element): void} onSetActive - 链接设置为活动时调用
 * @property {function(to, element): void} onSetInactive - 链接失去活动状态时调用
 * @property {boolean} ignoreCancelEvents - 忽略取消动画滚动的事件
 * @property {boolean} hashSpy - 基于spy更新hash，必须设置containerId才能滚动特定元素
 */
Anchor.ScrollLink = ScrollLink;

export default Anchor;
